import { createSlice } from "@reduxjs/toolkit";
import { StepperSliceState } from "../types";

const initialState: StepperSliceState = {
  activeStep: 0,
};

const StepperStateSlice = createSlice({
  name: "StepperSlice",
  initialState,
  reducers: {
    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },
  },
});

export const { setActiveStep } = StepperStateSlice.actions;
export default StepperStateSlice.reducer;
